import { toJSONSchema } from "zod";

import { zEntityComposerDefinition, zRelationComposerDefinition } from "./types";

export const entityComposerJsonSchema = toJSONSchema(zEntityComposerDefinition);

export const relationComposerJsonSchema = toJSONSchema(zRelationComposerDefinition);
